import { memo } from 'react';

import { FlexRow } from 'ui-components/components/flex';

import style from '../tree-navigation.module.less';

/**
 * @typedef {object} TreeItem
 * @property {React.ReactNode} customIcon
 */

/**
 * Renders an icon for a tree navigation item.
 * @param {object} props
 * @param {TreeItem} props.item - The tree item
 * @param {React.ReactNode} [props.item.customIcon] - Custom icon component (typically FontAwesomeIcon or DataDrivenLogo)
 * @param {boolean} props.shouldRenderAnIcon - Whether to render an icon
 * @returns {JSX.Element | null}
 */
export const ItemIcon = memo(({ item, shouldRenderAnIcon }) => {
  const { customIcon } = item;

  if (!shouldRenderAnIcon || !customIcon) {
    return null;
  }

  return <FlexRow className={style['store-icon-wrapper']}>{customIcon}</FlexRow>;
});
